import { ITreeProps } from './tree.types'
import { useMemo } from 'react'
import treeUtils from './tree.utils'
import TreeGroupNode from './components/TreeGroupNode'

const Tree = <Leaf extends Record<string, any>, Group extends Record<string, any>, GroupId extends string | number>(
  props: ITreeProps<Leaf, Group, GroupId>
) => {
  const leafsMap = useMemo(() => {
    return treeUtils.buildGroupIdToLeafsMap(props.leafs)
  }, [props.leafs])

  const groupsPrecomputed = useMemo(() => {
    const rootGroups = props.groups.filter((g) => !g.parentId)
    const groupsMap = treeUtils.buildGroupIdToGroupsMap(props.groups)

    return { rootGroups, groupsMap }
  }, [props.groups])

  return (
    <div>
      {groupsPrecomputed.rootGroups.map((g) => (
        <TreeGroupNode
          onClickGroup={props.onClickGroup}
          onClickLeaf={props.onClickLeaf}
          isRoot={true}
          key={g.id}
          groupsMap={groupsPrecomputed.groupsMap}
          leafsMap={leafsMap}
          group={g}
          renderLeaf={props.renderLeaf}
          renderGroup={props.renderGroup}
          expandCtrl={props.expandCtrl}
          leafSelectCtrl={props.leafSelectCtrl}
          styling={props.styling}
        />
      ))}
    </div>
  )
}

export default Tree
